import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { waLink } from "@/lib/site";

const Col = ({ title, children }) => (
  <div>
    <p className="text-[11px] tracking-[0.3em] uppercase text-[#8F6B3A] mb-5">{title}</p>
    <div className="flex flex-col gap-3 text-sm text-[#5A4C3C]">{children}</div>
  </div>
);

const FLink = ({ to, children, testid }) => (
  <Link to={to} data-testid={testid} className="hover:text-[#2B2118] transition-colors duration-300 w-fit">
    {children}
  </Link>
);

export const Footer = () => {
  const [email, setEmail] = useState("");
  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await api.post("/newsletter", { email });
      toast.success("Welcome to the house. You'll hear from us rarely, and only when it matters.");
      setEmail("");
    } catch {
      toast.error("Something went wrong. Please try again.");
    }
  };

  return (
    <footer className="border-t border-[#2B2118]/[0.06] bg-[#C0B29A]">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-20">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-10 pb-16 border-b border-[#2B2118]/[0.06]">
          <div>
            <p className="font-display text-3xl md:text-4xl text-[#2B2118]">Bonheur Eternal</p>
            <p className="mt-3 text-sm text-[#6E6151] tracking-[0.25em] uppercase">Be Remembered.</p>
          </div>
          <form onSubmit={subscribe} className="flex w-full max-w-md border-b border-[#8F6B3A]/40 pb-2">
            <input
              data-testid="newsletter-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email — for rare correspondence"
              className="flex-1 bg-transparent outline-none text-sm text-[#2B2118] placeholder:text-[#6E6151]"
            />
            <button data-testid="newsletter-submit-btn" type="submit" className="text-xs tracking-[0.2em] uppercase text-[#8F6B3A] hover:text-[#2B2118] transition-colors">
              Subscribe
            </button>
          </form>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 py-16">
          <Col title="Customer Care">
            <FLink to="/customer-care/shipping-delivery" testid="footer-link-shipping">Shipping &amp; Delivery</FLink>
            <FLink to="/customer-care/returns-exchanges" testid="footer-link-returns">Returns &amp; Exchanges</FLink>
            <FLink to="/customer-care/privacy" testid="footer-link-privacy">Privacy</FLink>
            <FLink to="/customer-care/terms" testid="footer-link-terms">Terms &amp; Conditions</FLink>
            <FLink to="/customer-care/contact" testid="footer-link-contact">Contact Us</FLink>
          </Col>
          <Col title="Explore">
            <FLink to="/collection" testid="footer-link-collection">The Collection</FLink>
            <FLink to="/scent-finder" testid="footer-link-scent-finder">Scent Finder</FLink>
            <FLink to="/decants" testid="footer-link-decants">Decants</FLink>
            <FLink to="/solid-perfume" testid="footer-link-wax">Solid Perfume</FLink>
            <FLink to="/story" testid="footer-link-story">Our Story</FLink>
            <FLink to="/journal" testid="footer-link-journal">Journal</FLink>
          </Col>
          <Col title="Connect">
            <a data-testid="footer-whatsapp" href={waLink("Hello Bonheur Eternal")} target="_blank" rel="noopener noreferrer" className="hover:text-[#2B2118] transition-colors w-fit">WhatsApp</a>
            <a data-testid="footer-email" href="mailto:hello.bonheureternal@gmail.com" className="hover:text-[#2B2118] transition-colors w-fit">Email</a>
            <a data-testid="footer-instagram" href="https://instagram.com/bonheureternal" target="_blank" rel="noopener noreferrer" className="hover:text-[#2B2118] transition-colors w-fit">Instagram</a>
          </Col>
          <Col title="Legal">
            <p>© {new Date().getFullYear()} Bonheur Eternal B.E.</p>
            <p className="text-[#6E6151]">Karachi — delivering all over Pakistan.</p>
            <p className="text-[#6E6151]">Jeddah — delivering all over Saudi Arabia.</p>
          </Col>
        </div>
      </div>
    </footer>
  );
};
